import { render, staticRenderFns } from "./GRITable2021.vue?vue&type=template&id=d7972012"
import script from "./GRITable2021.vue?vue&type=script&lang=js"
export * from "./GRITable2021.vue?vue&type=script&lang=js"
import style0 from "./GRITable2021.vue?vue&type=style&index=0&id=d7972012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports